import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class SeePartsModal extends Component {
  constructor(props) {
    super(props);
    this.renderTable = this.renderTable.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {accessoryOrder} = this.props;
    if (accessoryOrder.order && accessoryOrder.order !== prevProps.accessoryOrder.order) {
      this.fetchData();
    }
  }

  fetchData() {
    const {accessoryOrder} = this.props;
    const params = {
      'showStockInLog': 'no',
      'chassis': accessoryOrder.chassis,
      'katashiki': accessoryOrder.katashiki,
    };
    this.props.fetchPartsByOrder(accessoryOrder.order, params);
  }

  onCloseModalClick() {
    this.props.onCloseModal();
  }
  
  renderItems() {
    const {list} = this.props;
    if (!list.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>No hay datos Disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return list.map((item, index) => {
      return (
        <Table.Row key={index} >
          <Table.Cell textAlign='center'>{item.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{item.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{item.quantity}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }
  
  renderTable() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Código del Item</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Nombre</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Cantidad Requerida</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {this.renderData()}
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {accessoryOrder, modalWasOpen} = this.props;

    return (
      <Modal size='large' className='stock-download-modal' open={modalWasOpen}>
        <Modal.Header>
          Repuestos asociados al combo: {accessoryOrder.combo}
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>
            {this.renderTable()}
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.stockDownload.loading,
    'list': state.stockDownload.parts,
    'sfx': state.stockDownload.sfx,
  };
};

const {
  fetchPartsByOrder,
} = Actions;

export default connect(mapStateToProps, {
  fetchPartsByOrder,
})(SeePartsModal);
